(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("laxar"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["laxar", "moment"], factory);
	else if(typeof exports === 'object')
		exports["laxar-uikit"] = factory(require("laxar"), require("moment"));
	else
		root["laxar-uikit"] = factory(root["laxar"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition